<template>
  <div class="px-3 mt-n3">
    <div
      class="header url-fetcher"
      :class="{'header--square': submitted}"
    >
      <div class="d-flex">
        <input
          ref="input"
          v-model="urlToFetch"
          type="text"
          class="form-control"
          placeholder="Enter website URL"
          @focus="scrollToTop"
          @keydown.enter="onEnter"
        >
        <base-icon
          :icon="!submitted ? 'enter_input' :'refresh_input' "
          class="icon-position"
          style="position: absolute; right: 60px; margin-top: 10px;"
          @click="onEnter"
        />
        <!-- <base-button
          inverse
          nowrap
          :disabled="urlToFetch === '' || !isURL(urlToFetch)"
          @click="onEnter"
        >
          {{ $t('outreach.product.load') }}
        </base-button> -->
      </div>
    </div>
    <div
      style="background: #FAF9F7; overflow-x: scroll;"
    >
      <div
        v-if="urlToFetch != '' && !isURL(urlToFetch)"
        style="top: -17px; position: relative; margin-left: 17px;"
      >
        <small class="form-text text-muted">
          Invalid album image URL, got: {{ urlToFetch || "(blank)" }}
        </small>
      </div>
      <div v-if="!submitted" class="d-flex image_url">
        <div>
          <base-icon
            icon="add-image"
            class="icon-position"
          />
        </div>
        <div
          class="image_url__text"
        >
          Add a website URL to extract images
        </div>
      </div>
      <!-- <small class="form-text text-muted" v-if="isURL(urlToFetch)">Press "Enter" to fetch</small> -->
      <template v-if="isLoading">
        <div class="text-center p-5 text-muted image_url">
          <font-awesome-icon
            icon="spinner"
            spin
          /> Loading
        </div>
      </template>
      <template v-if="submitted && !isLoading">
        <div>
          <base-text
            v-if="displayTitle && product.title && product.sync_id && product.sync_id.length"
            bold
            size="md"
            class="ml-2"
          >
            {{ product.title }}
          </base-text>
          <!-- {{ product.description }}
        {{ product.price }} -->
          <div v-if="product.images.length <= 0">
            <base-text
              size="m"
              :style="{'color': '#646464'}"
            >
              We're having trouble retrieving these images. Please click <strong>Load Image</strong> button to try again.
            </base-text>
          </div>
          <div
            v-if="product.images.length > 0"
            style="background: #FAF9F7;"
          >
            <!-- <div class="mb-1">Results: <small><a href="#" @click.prevent="onCancel">(Cancel)</a></small></div> -->
            <div class="d-flex flex-wrap grid-thumb">
              <div
                v-for="(image, index) in product.images"
                :key="index"
                class="product__thumb"
                :class="{'product__thumb--selected': isSelected(image)}"
                @click.stop.prevent="select(product, image)"
              >
                <img
                  class="product__thumb__img"
                  :src="image.image_url"
                  alt=""
                  width="191.5px"
                  height="224px"
                >
                <div
                  v-if="isSelected(image)"
                  class="product__thumb__icon"
                >
                  <base-icon
                    icon="selected"
                    class="icon-position"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'ProductSelectorFetch',
  mixins: [whichbrowser],
  props: {
    disableMultiSelect: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      displayTitle: false,
      urlToFetch: '',
      submitted: false,
      product: {},
      isLoading: false,
      selected: [],
    };
  },
  watch: {
    selected(newval) {
      this.$emit('input', newval);
    },
    value(newval) {
      this.selected = newval;
    },
    urlToFetch(newval) {
      if (this.isURL(newval)) {
        this.fetchFromURL();
      }
    },
  },
  mounted() {
    window.onfocus = () => {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    };
    this.$nextTick().then(this.$refs.input.focus());
  },
  destroyed() {
    window.onfocus = () => {};
  },
  methods: {
    /** This method is moves the screen to fix a weird iOS safari behaviour
     *  more info: https://blog.opendigerati.com/the-eccentric-ways-of-ios-safari-with-the-keyboard-b5aa3f34228d
     */
    scrollToTop() {
      if (!this.isIPad) {
        return;
      }
      this.$nextTick().then(() => {
        window.scroll({
          top: 0,
          left: 0,
        });
      });
    },
    fetchFromURL() {
      this.submitted = true;
      this.$emit('submitted');
      this.isLoading = true;
      if (!this.urlToFetch) {
        this.isLoading = false;
      }

      this.$emit('fetched', false); // Reset fetch

      axios.post('https://us-central1-stylelab-scrap.cloudfunctions.net/stylelab-scrap-v3-dev-first', {
        url: this.urlToFetch,
      }).then((r) => {
        this.product = r.data;
        this.$emit('fetched', this.product.images.length > 0);
        this.product.images.map((img) => img.image_url.replace('&', '&amp;')); // Quick fix
        this.selected = []; // Reset selection
        this.isLoading = false;
      }).catch((e) => {
        console.log(e);
        this.product = {
          images: [],
        };
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onEnter(event) {
      if (this.isURL(this.urlToFetch)) {
        this.fetchFromURL();
      }
    },
    onCancel() {
      this.submitted = false;
      this.urlToFetch = '';
      this.product = {};
      this.selected = [];
      this.$emit('cancel');
    },
    isURL(str) {
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!-/]))?/;
      return pattern.test(str);
    },
    pasteFromURL() {
      try {
        navigator.clipboard.readText().then((text) => {
          if (text === this.urlToFetch) {
            return;
          }

          if (this.isURL(text)) {
            this.urlToFetch = text;
            this.onEnter();
          }
        }).catch((e) => {
          console.log(e);
        });
      } catch (e) {
        console.log(e);
      }
    },
    isSelected(img) {
      return this.selected.find((obj) => {
        if (obj.image_url === img.image_url) {
          return true;
        }
        return false;
      });
    },
    select(item, image) {
      /*
         TOGGLE an album/product image when one is clicked,
         providing an IMPORTANT internal dictionary representation of it
         in 'productImageSelectionRecord' which gets referenced elsewhere
         see:  Vuex src/_store/productImage.module.js
       */
      const existing = this.isSelected(image);
      if (!existing) {
        // ...then ADD it to what we 'this.selected' "to toggle it on.
        // 'productImageSelectionRecord' is how we'll keep track

        const productImageSelectionRecord = {
          image_url: image.image_url,
          product: item,
          site_url: image.site_url || item.site_url,
        };
        console.log('FE:O{E');
        console.log(productImageSelectionRecord);
        console.log(image);
        console.log(item);

        if (this.disableMultiSelect) { // disables multi selector for url images loading
          this.selected = [];
        }
        this.$set(this.selected, this.selected.length, productImageSelectionRecord);
      } else {
        this.$delete(this.selected, this.selected.indexOf(existing));
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.fetched-image {
  object-fit: cover;
}

.header {
  background-color: $gray-light;
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  &--square {
    border-radius: 0;
  }
  // padding-top: 19px;
  // padding-bottom: 495px;
}

.url-fetcher {
  display: grid;
  height: 100px;
  align-items: center;
}
.form-text{
  margin-top: unset;
}
.image_url{
  margin: 11%;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__text{
    font-family: 'SilkaLight';
    font-weight: 300;
    font-size: 16px;
    line-height: 140%;
    color: #1B1B1B;
    padding-top: 1.5rem;
  }
}
.product__thumb--selected {
  box-shadow: unset;
  width: 191.5px;
  height: 224px;
}
.product__thumb__icon {
  background-color: unset;
}
.product__thumb{
  max-width: calc(230px + 1%);
  height: 225px;
  width: 100%;
  margin: unset !important;
  margin-inline: 1px !important;

  @media (max-width: 575px){
    max-width: 275px;
  }
  @media (max-width: 769px){
    max-width: 144px;
  }
  @media only screen and (min-width: 770px) and (max-width: 780px) {
    max-width: calc(212px + -2%);
  }
  @media only screen and (min-width: 781px) and (max-width: 944px) {
    max-width: calc(145px + 2%);
  }
  @media only screen and (min-width: 945px) and (max-width: 1145px) {
    max-width: calc(180px + 1%);
  }
}
.grid-thumb {
  gap: 15px;
  padding-left: 17px;
  padding-right: 17px;
}
</style>
